// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3VOwM","signatureBlock":"Footer_signatureBlock__4t2Lc","signature":"Footer_signature__2Rd5g"};